import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <section id="cta" className="py-24 lg:py-40 bg-deep-azure text-white relative overflow-hidden" data-id="element-13">
      <div className="absolute inset-0 bg-ocean-radial" data-id="element-14"></div>
      <div className="absolute inset-0 ocean-pattern opacity-40" data-id="element-15"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[80%] h-[60%] bg-azure/10 blur-[140px] rounded-full" data-id="element-16"></div>
      <div className="absolute bottom-0 right-0 w-[40%] h-[60%] bg-vivid-orange/10 blur-[140px] rounded-full" data-id="element-17"></div>

      <div className="max-w-5xl mx-auto px-6 lg:px-8 relative z-10 text-center" data-id="element-18">
        <FadeIn data-id="element-19">
          <p className="text-[11px] font-semibold tracking-[0.4em] uppercase text-golden-yellow mb-10" data-id="element-20">
            Join the Ecosystem
          </p>

          <h2 className="text-4xl md:text-6xl lg:text-7xl font-display font-medium leading-[1.05] mb-4 tracking-tight" data-id="element-21">
            The future of women's economic advancement
          </h2>
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-display italic font-light leading-[1.05] mb-12 text-golden-yellow tracking-tight" data-id="element-22">
            requires more than visibility.
          </h2>

          <div className="editorial-rule w-32 mx-auto mb-12" data-id="element-23"></div>

          <p className="text-xl md:text-2xl text-white/70 font-display italic font-light max-w-3xl mx-auto mb-16 leading-relaxed" data-id="element-24">
            It requires infrastructure, execution, access, and measurable
            support.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8" data-id="element-25">
            <a href="https://fundher-academy.mn.co" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-vivid-orange hover:bg-vivid-orange-light text-white font-medium text-sm tracking-[0.05em] uppercase py-4 px-10 rounded-sm transition-all duration-300 w-full sm:w-auto group" data-id="element-26">
              Join the Ecosystem
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-27" />
            </a>
            <a href="https://fundher-academy.mn.co" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center border border-azure/60 hover:border-azure hover:bg-azure/10 text-azure font-medium text-sm tracking-[0.05em] uppercase py-4 px-10 rounded-sm transition-all duration-300 w-full sm:w-auto" data-id="element-28">
              Partner With Us
            </a>
          </div>

          <a href="https://fundher-academy.mn.co" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-golden-yellow/80 hover:text-golden-yellow font-medium text-sm tracking-[0.05em] uppercase transition-colors" data-id="element-29">
            Participate in the Research
            <ArrowRight className="w-4 h-4" data-id="element-30" />
          </a>
        </FadeIn>
      </div>
    </section>;
}